import { render, staticRenderFns } from "./website-success-stories.vue?vue&type=template&id=13be2b2a&scoped=true"
import script from "./website-success-stories.vue?vue&type=script&lang=js"
export * from "./website-success-stories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13be2b2a",
  null
  
)

export default component.exports